export const AdminListingRequestDtoDummy = {
  localizedName: {},
  localizedTitle: {},
  localizedDesc: {},
  bedroomsNumber: 0,
  bathroomsNumber: 0,
  localizedAddress: {},
  hostawayId: {},
  region: {
    id: {},
    localizedName: {},
    createDate: {},
    modifyDate: {},
    creator: {
      username: {},
    },
    modifier: {
      username: {},
    },
  },
  seq: {},
  hasParking: false,
  size: {},
  minGuest: {},
  maxGuest: {},
  cleaningFee: {},
  extraPersonPrice: {},
  latitude: {},
  longitude: {},
  wifiUsername: {},
  wifiPassword: {},
  isRecommend: false,
  isNew: false,
  isActive: false,
  business: {
    id: {},
    localizedName: {},
    createDate: {},
    modifyDate: {},
    creator: {
      username: {},
    },
    modifier: {
      username: {},
    },
  },
  checkInTime: {},
  checkOutTime: {},
} as const;
